module.exports = __webpack_public_path__ + "img/dash-card-average-ticket.651ec3eb.svg";